import { Collection } from "@tblabs/truffle";
import { PicturePack } from "./PicturePack";
import { GalleryItem } from "./GalleryItem";


export class PicturePackToGalleryItemConverter
{
    public static Convert(pack: PicturePack): GalleryItem
    {
        return new GalleryItem({
            Name: pack.Name,
            OriginalUrl: pack.Original,
            NormalizedUrl: pack.Normalized,
            ThumbnailUrl: pack.Thumbnail,
            MiniUrl: pack.Mini,
        });
    }

    public static ConvertMany(packs: PicturePack[]): Collection<GalleryItem>
    {
        return new Collection(packs.map(x => this.Convert(x)));
    }
}
